"use client";

import DocumentationSidebar from "@/components/documentation/DocumentationSidebar";
import NewDocumentationModal from "@/components/documentation/NewDocumentationModal";
import Tiptap, { TipTapExtensions } from "@/components/Tiptap";
import { ToggleInput, ToggleLabel, ToggleSpan } from "@/components/ui/toggle";
import { getTokenData } from "@/helpers/token.helper";
import { getAuthAvailability } from "@/services/auth.service";
import {
  getDocumentationIndex,
  postUpdateDocumentation,
} from "@/services/documentation.service";
import { Content, Editor, JSONContent } from "@tiptap/react";
import { renderToReactElement } from "@tiptap/static-renderer";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export default function DocumentationDetails() {  
  const [isLoading, setIsLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [currentContent, setCurrentContent] = useState<Content | null>("");
  const [currentContentJSON, setCurrentContentJSON] =
    useState<JSONContent | null>();
  const [documentCreatorID, setDocumentCreatorID] = useState("");
  const [userDetails, setUserDetails] = useState<any>();

  const params = useParams();
  const id = params?.documentation_id as string;

  const saveDocumentation = async (editor: Editor) => {
    const formData = new FormData();
    formData.append("id", id);
    formData.append("content", JSON.stringify(editor.getJSON()));

    const result = await postUpdateDocumentation(formData);
    console.log(result);
  };

  const loadNewContent = (editor: Editor) => {
    setCurrentContent(editor.getHTML());
    setCurrentContentJSON(editor.getJSON());
  };

  const loadDocumentation = async () => {
    setIsLoading(true);
    try {
      await getDocumentationIndex(id).then((r) => {
        // Data for the TipTap component
        setCurrentContent(r.Content);

        setDocumentCreatorID(r.CreatorID);

        // Data for the visual compoenent
        setCurrentContentJSON(r.Content as unknown as JSONContent);
        setIsLoading(false);
      });
    } catch (error) {
      var isAuthorized = await getAuthAvailability();
      if(isAuthorized){
        document.location = "/documentation/1";
      }
    }
  };

  useEffect(() => {
    if (currentContent?.length === 0) {
      loadDocumentation();
    }
    if(userDetails == null){
      setUserDetails(getTokenData()['user']);
    }
  }, [currentContent, loadDocumentation]);

  return (
    <div className="grid grid-cols-3 gap-4">
      <div className="col-span-2 dark:bg-black dark:text-white">
        <h1>Documentation Page</h1>
        <div>
          <NewDocumentationModal parentID={id}/>

          {userDetails?.U_ID == documentCreatorID && (
            <div className="w-[200px]">
              <ToggleLabel className="ps-0">
                <span className="p-1">Edit content</span>
                <ToggleInput
                  checked={isEditing}
                  onChange={() => {
                    setIsEditing(!isEditing);
                  }}
                />
                <ToggleSpan />
              </ToggleLabel>
            </div>
          )}
          <div className="card">
            {!isLoading && isEditing && (
              <Tiptap
                defaultValue={currentContent}
                saveDocumentation={saveDocumentation}
                loadNewContent={loadNewContent}
              />
            )}
          </div>
          {!isLoading && !isEditing && (
            <>
              <h1>Content: </h1>
              <div className="tiptap">
                {currentContentJSON ? (
                  renderToReactElement({
                    content: currentContentJSON,
                    extensions: TipTapExtensions,
                  })
                ) : (
                  <></>
                )}
              </div>
            </>
          )}
        </div>
      </div>
      <DocumentationSidebar />
    </div>
  );
}
